export enum UserRole {
    NZMB_STAFF = 1,
    EXPORTER = 2,
    AUDITOR_QCVS = 3,
    AUDITOR_PH = 4,
}